(function () {
  'use strict';

  var instances = new WeakMap();
  var pending = new WeakSet();
  var scheduleIdle = window.requestIdleCallback || function (callback) { return setTimeout(callback, 1); };

  var sectionObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var sectionEl = entry.target;
          sectionObserver.unobserve(sectionEl);
          pending.delete(sectionEl);
          startInstance(sectionEl, sectionEl.__exnStarsMarker);
        });
      }, { rootMargin: '520px 0px', threshold: 0.01 })
    : null;

  function startInstance(sectionEl, marker) {
    if (!sectionEl || !marker || instances.has(sectionEl)) return;
    instances.set(sectionEl, createStars(sectionEl, marker));
  }

  function initAll() {
    document.querySelectorAll('[data-exn-section-stars-marker]').forEach(function (marker) {
      var sectionEl = getSectionElement(marker);
      if (!sectionEl || instances.has(sectionEl) || pending.has(sectionEl)) return;

      sectionEl.__exnStarsMarker = marker;
      pending.add(sectionEl);

      if (sectionObserver) {
        sectionObserver.observe(sectionEl);
      } else {
        scheduleIdle(function () {
          pending.delete(sectionEl);
          startInstance(sectionEl, marker);
        });
      }
    });
  }

  function getSectionElement(marker) {
    var sibling = marker.nextElementSibling;
    while (sibling && !/^(SECTION|FOOTER|HEADER|MAIN|DIV)$/i.test(sibling.tagName)) {
      sibling = sibling.nextElementSibling;
    }
    return sibling || marker.closest('.shopify-section') || marker.parentElement;
  }

  function resolveStarColor(sectionEl, mode) {
    // mode: 'white' | 'black' | 'auto'
    if (mode === 'white') return '#ffffff';
    if (mode === 'black') return '#000000';
    // auto : déduire de la luminance du fond effectif
    var el = sectionEl;
    var bg = '';
    while (el) {
      var c = window.getComputedStyle(el).backgroundColor;
      if (c && c !== 'transparent' && c !== 'rgba(0, 0, 0, 0)') { bg = c; break; }
      el = el.parentElement;
    }
    var m = bg.match(/rgba?\(([^)]+)\)/);
    if (!m) return '#ffffff';
    var parts = m[1].split(',').map(function (v) { return parseFloat(v); });
    var r = parts[0], g = parts[1], b = parts[2];
    // luminance perçue (0..255)
    var lum = (0.299 * r + 0.587 * g + 0.114 * b);
    return lum > 140 ? '#000000' : '#ffffff';
  }

  function createStars(sectionEl, marker) {
    var scheme = marker.dataset.colorScheme || 'background-1';
    var enabled = marker.dataset.enabled !== 'false';
    var starColorMode = marker.dataset.starColor || 'auto';

    if (!sectionEl.classList.contains('color-' + scheme)) sectionEl.classList.add('color-' + scheme);
    if (!sectionEl.classList.contains('gradient')) sectionEl.classList.add('gradient');
    sectionEl.classList.add('exn-section-stars-host');

    if (!enabled) {
      return { destroy: function () {} };
    }

    sectionEl.classList.add('exn-section-stars-host--enabled');

    var canvas = document.createElement('canvas');
    canvas.className = 'exn-section-stars-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    sectionEl.insertBefore(canvas, sectionEl.firstChild);

    Array.prototype.forEach.call(sectionEl.children, function (child) {
      if (child === canvas || child === marker) return;
      var style = window.getComputedStyle(child);
      if (style.position === 'static') child.style.position = 'relative';
      if (style.zIndex === 'auto') child.style.zIndex = '2';
    });

    var ctx = canvas.getContext('2d', { alpha: true });
    var starColor = resolveStarColor(sectionEl, starColorMode);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var alive = true;
    var raf = null;
    var w = 0;
    var h = 0;
    var renderH = 0;
    var dpr = 1;
    var stars = [];
    var visible = true;
    var resizeRaf = null;

    var observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          visible = entries[0] ? entries[0].isIntersecting : true;
        }, { rootMargin: '160px' })
      : null;

    if (observer) observer.observe(sectionEl);

    var resizeObserver = 'ResizeObserver' in window
      ? new ResizeObserver(scheduleResize)
      : null;

    if (resizeObserver) resizeObserver.observe(sectionEl);

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function scheduleResize() {
      if (!alive || resizeRaf) return;
      resizeRaf = requestAnimationFrame(function () {
        resizeRaf = null;
        resize();
      });
    }

    function resize() {
      var mobile = isMobile();
      dpr = mobile ? 1 : Math.max(1, Math.min(2, window.devicePixelRatio || 1));
      w = Math.max(1, sectionEl.clientWidth);
      h = Math.max(1, sectionEl.clientHeight);
      renderH = Math.max(1, Math.min(h, mobile ? 1400 : 3200));
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(renderH * dpr);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var area = w * renderH;
      var count = Math.max(mobile ? 32 : 50, Math.min(mobile ? 120 : 220, Math.floor(area / (mobile ? 16000 : 14000))));
      stars = new Array(count).fill(0).map(function () {
        var angle = Math.random() * Math.PI * 2;
        var speed = Math.random() * (mobile ? 0.12 : 0.18) + 0.035;
        return {
          x: Math.random() * w,
          y: Math.random() * renderH,
          r: Math.random() * (mobile ? 0.9 : 1.2) + 0.2,
          a: Math.random() * 0.48 + 0.12,
          tw: Math.random() * 0.02 + 0.006,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed
        };
      });
    }

    function draw() {
      if (!alive) return;
      raf = requestAnimationFrame(draw);
      if (!visible) return;

      ctx.clearRect(0, 0, w, renderH);
      for (var i = 0; i < stars.length; i++) {
        var st = stars[i];
        st.a += st.tw * (Math.random() > 0.5 ? 1 : -1);
        st.a = Math.max(0.09, Math.min(0.82, st.a));
        st.x += st.vx;
        st.y += st.vy;
        if (st.x > w + 10) {
          st.x = -10;
        } else if (st.x < -10) {
          st.x = w + 10;
        }
        if (st.y > renderH + 10) {
          st.y = -10;
        } else if (st.y < -10) {
          st.y = renderH + 10;
        }

        ctx.globalAlpha = st.a;
        ctx.beginPath();
        ctx.arc(st.x, st.y, st.r, 0, Math.PI * 2);
        ctx.fillStyle = starColor;
        ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    resize();
    if (!reduce) draw();
    window.addEventListener('resize', resize);

    return {
      destroy: function () {
        alive = false;
        if (raf) cancelAnimationFrame(raf);
        if (observer) observer.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        window.removeEventListener('resize', resize);
        canvas.remove();
        sectionEl.classList.remove('exn-section-stars-host', 'exn-section-stars-host--enabled');
      }
    };
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    var sectionEl = event.target;
    if (sectionObserver) sectionObserver.unobserve(sectionEl);
    pending.delete(sectionEl);
    if (instances.has(sectionEl)) {
      instances.get(sectionEl).destroy();
      instances.delete(sectionEl);
    }
  });

  if (document.readyState !== 'loading') initAll();
})();
